import { createFileRoute } from '@tanstack/react-router';

import { LegalPage } from '@/features/legalPages/LegalPage';

export const Route = createFileRoute('/_static/privacy-policy')({
	component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
	return <LegalPage page="privacyPolicy" isPlaceholder />;
}
